define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ApiKeyViewModel = (function () {
        function ApiKeyViewModel(id, dataAdministratorId, dataAdministratorMemberId, description, value, expiresAt, allowRefresh, active) {
            this.id = id;
            this.dataAdministratorId = dataAdministratorId;
            this.dataAdministratorMemberId = dataAdministratorMemberId;
            this.description = description;
            this.value = value;
            this.expiresAt = expiresAt;
            this.allowRefresh = allowRefresh;
            this.active = active;
        }
        return ApiKeyViewModel;
    }());
    exports.default = ApiKeyViewModel;
});
